import TestingLaboratory from "../../views/createHauls/Index.vue";

const TestingLaboratoryRoute = [
  {
    path: "/testing-laboratory",
    name: "TestingLaboratory",
    component: TestingLaboratory,
  },
];

export default TestingLaboratoryRoute;
